(function () {
  'use strict';

  function initGallery(section) {
    var grid = section.querySelector('[data-sg-grid]');
    var filterBar = section.querySelector('[data-sg-filters]');
    var loadMoreBtn = section.querySelector('[data-sg-load-more]');
    var prevBtn = section.querySelector('[data-sg-prev]');
    var nextBtn = section.querySelector('[data-sg-next]');
    var ctaBtn = section.querySelector('[data-sg-button]');
var ctaText = section.querySelector('[data-sg-button-text]');
var buttonData = JSON.parse(section.dataset.buttons || '{}');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.children);
    var layout = section.getAttribute('data-layout') || 'grid';
    var itemsPerLoad = parseInt(section.getAttribute('data-items-per-load'), 10) || cards.length;
    // var activeFilter = 'all';
var activeBtn = filterBar ? filterBar.querySelector('.sg-filter-btn.is-active') : null;
var activeFilter = activeBtn
  ? activeBtn.getAttribute('data-sg-filter')
  : 'instagram';
    var visibleCount = itemsPerLoad;
    var carouselIndex = 0;

    function matchesFilter(card) {
      return activeFilter === 'all' || card.getAttribute('data-sg-platform') === activeFilter;
    }

    function updateButton(platform) {
  if (!ctaBtn || !ctaText || !buttonData[platform]) return;

  ctaBtn.href = buttonData[platform].url || "#";
  ctaText.textContent = buttonData[platform].text || "";
}

  //   function render() {
  //  var filtered = cards.filter(matchesFilter);

  //     cards.forEach(function (card) { 
  //       card.classList.add('sg-hidden');
  //     });

  //     if (layout === 'carousel') {
  //       filtered.forEach(function (card) {
  //         card.classList.remove('sg-hidden');
  //       });
  //       carouselIndex = 0;
  //       updateCarousel();
  //       return;
  //     }

  //     filtered.forEach(function (card, i) {
  //       if (i < visibleCount) {
  //         card.classList.remove('sg-hidden');
  //       }
  //     });

  //     if (loadMoreBtn) {
  //       if (visibleCount >= filtered.length) {
  //         loadMoreBtn.classList.add('sg-hidden');
  //       } else {
  //         loadMoreBtn.classList.remove('sg-hidden');
  //       }
  //     }
  //   }
function render() {
  var filtered = cards.filter(matchesFilter);

  cards.forEach(function(card) {
    card.classList.add('sg-hidden');
  });

  if (layout === 'carousel') {
    filtered.forEach(function(card) {
      card.classList.remove('sg-hidden');
    });

    carouselIndex = 0;
    updateCarousel();
    return;
  }

  filtered.forEach(function(card, i) {
    if (i < visibleCount) {
      card.classList.remove('sg-hidden');
    }
  });

  if (loadMoreBtn) {
    loadMoreBtn.classList.toggle(
      'sg-hidden',
      visibleCount >= filtered.length
    );
  }
}
    if (filterBar) {
      filterBar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sg-filter]');
        if (!btn) return;

        filterBar.querySelectorAll('[data-sg-filter]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        activeFilter = btn.getAttribute('data-sg-filter');

updateButton(activeFilter);

visibleCount = itemsPerLoad;
render();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += itemsPerLoad;
        render();
      });
    }

    // Carousel logic
    function visibleCards() {
      return cards.filter(matchesFilter);
    }

    function columnsPerView() {
      var width = window.innerWidth;
      var styles = getComputedStyle(section);
      if (width <= 749) {
        return parseInt(styles.getPropertyValue('--sg-columns-mobile'), 10) || 2;
      }
      if (width <= 989) {
        return parseInt(styles.getPropertyValue('--sg-columns-tablet'), 10) || 3;
      }
      return parseInt(styles.getPropertyValue('--sg-columns-desktop'), 10) || 4;
    }

    function updateCarousel() {
      if (layout !== 'carousel') return;
      var visible = visibleCards();
      if (!visible.length) return;

      var cardWidth = visible[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap || 0) || 0;
      var maxIndex = Math.max(visible.length - columnsPerView(), 0);

      carouselIndex = Math.min(Math.max(carouselIndex, 0), maxIndex);
      var offset = carouselIndex * (cardWidth + gap);

      grid.style.transition = 'transform 0.45s ease';
      grid.style.transform = 'translateX(' + -offset + 'px)';

      if (prevBtn) prevBtn.disabled = carouselIndex <= 0;
      if (nextBtn) nextBtn.disabled = carouselIndex >= maxIndex;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        carouselIndex += 1;
        updateCarousel();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        carouselIndex -= 1;
        updateCarousel();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateCarousel, 150);
    });

   updateButton(activeFilter);
render();
  }

  function init() {
    document.querySelectorAll('[data-sg-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-sg-gallery]');
    if (section) initGallery(section);
  });
})();
